import { CreateReactDto } from "@server/modules/project/reaction/dto/create-react.dto";

import { usePost } from "../helpers";

export const postReaction = async (id: string, data: CreateReactDto) =>
  usePost(`/project/reaction/${id}`, data);
